<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">删除项目</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
            project_del提供了删除当前账号下的某个项目的功能。不可删除子账号下的项目。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/project_del">https://skfrm.cn/APIV2/project_del</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
    
        <h3 class="doc_main_h3">返回值说明</h3>
     
		<h3 class="doc_main_h3">通用错误码</h3>
	
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"data":{
		"total_person_number":"0",
		"total_terminal_number":"0",
		"project_name":"11112",
		"adminaccount_name":"11112",
		"createaccount_name":"11112",
		"adminaccount_id":"11112",
		"createaccount_id":"11112",
		"status":"1"
		}
	}
失败：
	{
		"error_code":"1",
		"error_msg":"fail"
	}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['FRM API-v2','项目管理','删除项目'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/projectmanagement/deleteitem.vue